<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <TableModalForm
          :headers="headers"
          :items="explanations"
          class="elevation-1"
          :loading="isLoading"
          name="Explanations"
          ref="table"
          :slots="[{ name: 'actions' }, { name: 'order' }]"
          show-select
          single-select
          sort-by="order"
          @creating="creating"
          @refresh="refresh"
          @item-selected="itemSelected"
        >
          <template v-slot:form>
            <FormExplanation
              :Explanation="editExplanation"
              :isSaving="isSaving"
              @save="save"
              @cancel="$refs.table.dialog = false" />
          </template>
          <template v-slot:order="{ item, index }">
            <v-btn icon @click="moveUp(item)">
              <v-icon v-if="index > 0" class="mr-2">{{ mdiArrowUpBold }}</v-icon>
            </v-btn>
            {{ item.order }}
            <v-btn icon @click="moveDown(item)">
              <v-icon v-if="index < (explanations.length - 1)" class="mr-2">
                {{ mdiArrowDownBold }}
              </v-icon>
            </v-btn>
          </template>
          <template v-slot:actions="{ item }">
            <v-btn-toggle>
              <v-btn color="default" small @click="edit(item)">
                {{ $t('common.buttons.edit')}}
              </v-btn>
              <v-btn color="error" small @click="remove(item)">
                {{ $t('common.buttons.delete')}}
              </v-btn>
            </v-btn-toggle>
          </template>
        </TableModalForm>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus, mdiArrowUpBold, mdiArrowDownBold } from '@mdi/js';
import loading from '@codehq/aurora-app-core/src/mixins/loading';
import TableModalForm from '@/components/TableModalForm.vue';
import FormExplanation from '../components/FormExplanation.vue';

export default {
  name: 'ListExplanation',
  module: 'Explanation',
  components: {
    FormExplanation,
    TableModalForm,
  },
  props: {
    Task: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [loading],
  data() {
    return {
      /**
       * Icons
       */
      mdiPlus,
      mdiArrowUpBold,
      mdiArrowDownBold,
      /**
       * Get/Set editing Explanation. Default to {}.
       */
      editExplanation: {},
      mode: 'add',
    };
  },
  computed: {
    /** Vuex states
      */
    ...mapState('explanations', ['explanations']),
    /**
     * Get table column headers
     */
    headers() {
      return [
        {
          text: this.$$t('order'),
          value: 'order',
        },
        {
          text: this.$$t('name'),
          value: 'name',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  watch: {
    Task() {
      this.refresh();
    },
  },
  async mounted() {
    await this.refresh();
  },
  methods: {
    /** Vuex methods
      */
    ...mapActions('explanations', [
      'LOAD_explanation',
      'CREATE_explanation',
      'UPDATE_explanation',
      'LOAD_explanations',
      'DELETE_explanation',
    ]),
    creating() {
      this.editExplanation = {
        order: this.explanations.length + 1,
        name: '',
      };
      this.mode = 'add';
    },
    async edit(item) {
      this.editExplanation = { ...item };
      this.mode = 'edit';
      this.$refs.table.dialog = true;
    },
    /**
      * Moves an item up in the list
      */
    async moveDown(item) {
      const { explanations } = this;
      const next = explanations.find((s) => s.order === (item.order + 1));
      const current = explanations.find((s) => s.order === item.order);
      next.order = item.order;
      current.order = item.order + 1;
      await this.UPDATE_explanation(next);
      await this.UPDATE_explanation(current);
      await this.refresh();
    },
    /**
      * Moves an item down in the list
      */
    async moveUp(item) {
      const { explanations } = this;
      const prev = explanations.find((s) => s.order === (item.order - 1));
      const current = explanations.find((s) => s.order === item.order);
      prev.order = item.order;
      current.order = item.order - 1;
      await this.UPDATE_explanation(prev);
      await this.UPDATE_explanation(current);
      await this.refresh();
    },
    /**
      * Executes refresh
      */
    async refresh() {
      this.isLoading = true;
      await this.LOAD_explanations();
      this.isLoading = false;
    },
    /** Delete Explanation from the collection
      */
    async remove(explanation) {
      this.isLoading = true;
      await this.DELETE_explanation(explanation.id);
      this.isLoading = false;
    },
    /** Vuex methods
      */
    /** Method used to save the item
      */
    async save(explanation) {
      this.isSaving = true;
      if (this.mode === 'add') {
        await this.CREATE_explanation(explanation);
      } else {
        await this.UPDATE_explanation(explanation);
      }
      this.isSaving = false;
      this.$refs.table.dialog = false;
    },
    itemSelected(item) {
      this.$emit('selected', item);
    },
  },
};
</script>

 <docs>
 # Explanation example

 '''js
 <Explanation />
 '''
 </docs>
